import { createSlice } from "@reduxjs/toolkit";
import { createApi } from "../../utils/api";
import { saveParameterConfiguration } from "../../common/endpoints";

const initialState = {
  data: null,
  loading: false,
  error: null,
};

export const saveParamConfig = createApi(
  saveParameterConfiguration,
  "POST"
);

const parameterConfigSlice = createSlice({
  name: "parameterConfig",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveParamConfig.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(saveParamConfig.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(saveParamConfig.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default parameterConfigSlice.reducer;
